"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendApi = void 0;
const createApi_1 = require("../../helpers/createApi");
const dashboard_1 = require("./dashboard");
const audiences_1 = require("./audiences");
const api_1 = require("./transactions/api");
const emotionsAI_1 = require("./emotionsAI");
exports.backendApi = (0, createApi_1.createAPIFactory)({
    dashboard: dashboard_1.dashboardApi,
    audiences: audiences_1.backendAudiences,
    transactions: api_1.backendTransactionsApi,
    emotionsAI: emotionsAI_1.emotionsAI,
});
//# sourceMappingURL=api.js.map